<template>
  <div :class="$style.wrapper">
    <div :class="[$style.leftContent, { [$style.active]: !isSigningUp }]">
      <a href="https://hackenproof.com">
        <img src="@/images/Logotype.svg" alt="logo" />
      </a>
      <div :class="$style.supportText">
        <UiKitTypography :type="MAP.H04D" :class="$style.supportTextTitle">
          New in HackenProof?
        </UiKitTypography>
        <UiKitTypography
          :type="MAP.B02D"
          :class="$style.supportTextDescription"
        >
          Start for free and see how our white hats community can reinforce your
          security.
        </UiKitTypography>
        <UiKitButton
          :big="true"
          :variant="'white'"
          :class="$style.supportTextButton"
          @click="isSigningUp = true"
        >
          Sign up
        </UiKitButton>
      </div>
    </div>
    <div :class="[$style.signUp, { [$style.active]: isSigningUp }]">
      <AuthHeader @log_in="isSigningUp = false" />
      <div :class="$style.picker">
        <img
          src="@/images/icons/big-logo.svg"
          :class="$style.pickerLogo"
          alt="picker"
        />
        <UiKitTypography :type="MAP.H04D" :class="$style.pickerTitle"
          >Welcome to HackenProof</UiKitTypography
        >
        <UiKitTypography :type="MAP.H05D" :class="$style.pickerDescription"
          >Let`s begin the adventure</UiKitTypography
        >
        <div :class="$style.pickerCards">
          <a v-for="card in cards" :class="$style.pickerCard" :href="card.href">
            <div :class="$style.pickerCardContent">
              <UiKitTypography :type="MAP.BUTTON02D">I'm a</UiKitTypography>
              <UiKitTypography :type="MAP.H04D">{{
                card.title
              }}</UiKitTypography>
              <UiKitTypography
                :type="MAP.H05D"
                :class="$style.pickerCardDescription"
                ><br />{{ card.description }}</UiKitTypography
              >
            </div>
            <div :class="$style.gradient"></div>
            <div :class="$style.pickerCardImageWrapper">
              <img
                :src="card.image"
                :class="$style.pickerCardImage"
                :alt="card.title"
              />
            </div>
          </a>
        </div>
      </div>
      <AuthFooter :class="$style.footer" />
    </div>
  </div>
</template>

<script setup>
import UiKitTypography from "@/ui-kit/Typography.vue";
import UiKitButton from "@/ui-kit/Button.vue";
import { MAP } from "@/constants/typography";
import { inject } from "vue";
import { INJECT_KEYS } from "@/constants/injectKeys";
import Hacker from "@/images/sign-in/Hacker.png";
import Company from "@/images/sign-in/Company.png";
import AuthFooter from "@/components/AuthFooter";
import AuthHeader from "@/components/AuthHeader";

const isSigningUp = inject(INJECT_KEYS.SIGN_UP_OPEN_DRAWER);

const cards = [
  {
    title: "HACKER",
    description: "I want to use my skills to help make web3 a safer place",
    image: Hacker,
    href: "/register",
  },
  {
    title: "COMPANY",
    description:
      "I want to make sure my company`s security is safe by rewarding hackers who find vulnerabilities",
    image: Company,
    href: "/register?sign_up=company",
  },
];
</script>

<style module lang="scss">
.wrapper {
  position: relative;

  overflow: hidden;
  min-height: 100vh;

  .leftContent {
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    position: absolute;
    top: 0;
    left: 0;
    padding: 40px 180px 40px 172px;
    width: 710px;
    pointer-events: none;

    @media screen and (max-width: 1920px) {
      padding: 40px 24px 40px 40px;
      width: 500px;
    }

    @media screen and (max-width: 1440px) {
      padding: 26px 16px 40px 40px;
      width: 420px;
    }

    @media screen and (max-width: 1200px) {
      padding: 26px 16px 40px 40px;
      width: 350px;
    }

    @media screen and (max-width: 990px) {
      padding: 16px;
      width: 264px;
    }

    @media screen and (max-width: 760px) {
      padding: 16px;
      width: 200px;
    }

    .supportText {
      margin-top: 184px;
      display: flex;
      flex-direction: column;
      gap: 24px;

      @media screen and (max-width: 1440px) {
        margin-top: 134px;
      }

      @media screen and (max-width: 990px) {
        margin-top: 124px;
      }
    }
  }

  .signUp {
    position: absolute;
    top: 0;
    left: 0;
    padding: 40px 180px 0px 180px;
    opacity: 0;
    transition: opacity 0.3s ease-in-out, pointer-events 0.3s ease-in-out;
    width: 100%;
    min-height: 100vh;
    overflow: hidden;

    @media screen and (max-width: 1920px) {
      padding: 40px 40px 0px;
    }

    @media screen and (max-width: 1440px) {
      padding: 24px 40px 0px;
    }

    @media screen and (max-width: 990px) {
      padding: 16px 16px 0px;
    }

    display: flex;
    flex-direction: column;
    align-items: center;
    pointer-events: none;

    .picker {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;

      .pickerLogo {
        margin-bottom: 16px;
      }

      .pickerTitle {
        margin-bottom: 8px;
        text-align: center;
      }

      .pickerDescription {
        margin-bottom: 40px;
        opacity: 0.4;
        text-align: center;
      }

      .pickerCards {
        display: flex;
        gap: 40px;

        @media screen and (max-width: 1200px) {
          gap: 24px;
        }

        @media screen and (max-width: 990px) {
          gap: 16px;
        }

        @media screen and (max-width: 760px) {
          flex-direction: column;
        }

        .pickerCard {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          width: 452px;
          height: 415px;
          border-radius: 24px;
          padding: 40px;
          position: relative;
          border: 1px solid rgba(255, 255, 255, 0.16);
          cursor: pointer;

          background: rgba(255, 255, 255, 0.16);

          box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
          backdrop-filter: blur(10px);
          transition: box-shadow 0.3s ease-in-out;
          overflow: hidden;

          @media screen and (max-width: 1440px) {
            height: 320px;
          }

          @media screen and (max-width: 990px) {
            width: auto;
            flex: 1 1;
            height: 415px;
          }

          @media screen and (max-width: 760px) {
            width: 100%;
            height: 268px;
            min-height: 268px;
            flex: 0 0;
            padding: 24px;
          }

          .gradient {
            z-index: 2;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 50%;

            background: linear-gradient(
              180deg,
              rgba(255, 255, 255, 0) 0%,
              rgba(255, 255, 255, 0.8) 100%
            );
            transition: height 0.3s ease-in-out;

            @media screen and (max-width: 760px) {
              height: 50%;
            }
          }

          .pickerCardContent {
            position: relative;
            z-index: 3;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            height: 100%;

            .pickerCardDescription {
              margin-top: -8px;
              overflow: hidden;
              max-height: 0px;
              font-size: 24px;
              line-height: 32px;
              transition: max-height 0.3s ease-in-out;

              @media screen and (max-width: 1200px) {
                font-size: 20px;
                line-height: 26px;
              }

              @media screen and (max-width: 960px) {
                max-height: unset;
                overflow: visible;
              }
            }
          }

          .pickerCardImageWrapper {
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 1;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: flex-end;

            @media screen and (max-width: 1440px) {
              bottom: -50px;
            }

            @media screen and (max-width: 990px) {
              bottom: 0px;
            }

            @media screen and (max-width: 760px) {
              bottom: -20px;
            }

            .pickerCardImage {
              transform-origin: bottom right;
              transition: transform 0.3s ease-in-out;

              @media screen and (max-width: 760px) {
                height: 260px;
              }
            }
          }

          &:hover {
            box-shadow: 0px 0px 40px 0px #9280da;
            .pickerCardDescription {
              max-height: 300px;
            }

            .gradient {
              height: 75%;
            }

            .pickerCardImageWrapper {
              .pickerCardImage {
                transform: scale(1.4);
              }
            }

            @media screen and (max-width: 990px) {
              .pickerCardImageWrapper {
                .pickerCardImage {
                  transform: scale(1);
                }
              }

              .gradient {
                height: 50%;
              }
            }
          }
        }
      }
    }

    .footer {
      width: 100%;
      margin-top: 40px;
      padding: 16px 0;
    }
  }

  .active {
    position: relative;
    z-index: 3;
    opacity: 1;
    transition-delay: 0.6s;
    pointer-events: auto;
  }
}
</style>
